<template>
  <div class="layout-profile">
    <div>
      <img src="/assets/layout/images/profile.png" alt="" />
    </div>
    <button class="p-link layout-profile-link" @click="onClick">
      <span class="username">{{ username }}</span>
      <i class="pi pi-fw pi-cog"></i>
    </button>
    <transition name="layout-submenu-wrapper">
      <ul v-show="expanded">
        <li v-if="false">
          <button class="p-link">
            <i class="pi pi-fw pi-user"></i><span>Benutzerkonto</span>
          </button>
        </li>
        <li v-if="false">
          <button class="p-link">
            <i class="pi pi-fw pi-inbox"></i><span>Benachrichtigungen</span
            ><span class="menuitem-badge">2</span>
          </button>
        </li>
        <li>
          <button class="p-link" @click="logout()">
            <i class="pi pi-fw pi-power-off"></i><span>Abmelden</span>
          </button>
        </li>
        <li v-if="false">
          <Button
            class="p-link"
            icon="pi pi-fw pi-power-off"
            label="Abmelden"
            @click="logout()"
          />
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { STORAGE_KEY_NAME } from "./api/http";
export default {
  data() {
    return {
      expanded: false,
      username: "Aufenthaltsraum",
    };
  },
  methods: {
    onClick(event) {
      this.expanded = !this.expanded;
      event.preventDefault();
    },
    updatePrivileges() {
      const fullName = this.$store.getters["auth/fullName"];
      this.username = this.$store.getters["auth/isAuthenticated"] ? fullName : "Aufenthaltsraum";
    },
    logout() {
      this.$znaApi.logout(false);
    },
  },
};
</script>

<style scoped></style>
